module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('InputDefaultForm', {
    attrs: {
      "dataInputOption": _vm.dataInputOption,
      "isFocused": _vm.isFocused,
      "success": _vm.success,
      "type": 'number'
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.dataInputOption = $event
      },
      "update:isFocused": function($event) {
        _vm.isFocused = $event
      },
      "blur": _vm.blur,
      "focus": _vm.focus,
      "keydown": _vm.keydown
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa689d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/forms/extended/InputNumber/InputCodePostalForm/InputCodePostalForm.vue.html
// module id = rhzf
// module chunks = 2